/*
  45R Collection Card - gallery swipe / arrows / QuickAdd spinner.
  Was inlined in 45R-collection-card.liquid, so every card on the page
  shipped its own 7KB copy. Loaded once per section instead; the
  _r45CardScriptLoaded guard still covers sections that co-exist on
  one page.
*/
(function() {
  // Prevent multiple script loading
  if (window._r45CardScriptLoaded) return;
  window._r45CardScriptLoaded = true;

  // Swipe hint: triggers once per page load on the first multi-image card
  let swipeHintTriggered = false;

  // QuickAdd spinner state
  let loadingButton = null;
  let checkInterval = null;

  function removeLoading() {
    if (loadingButton) {
      loadingButton.classList.remove('is-loading');
      loadingButton = null;
    }
    if (checkInterval) {
      clearInterval(checkInterval);
      checkInterval = null;
    }
  }

  // Initialize QuickAdd spinner for a card
  function initQuickAddSpinner(card) {
    const btn = card.querySelector('.quick-add__button');
    if (!btn || btn.dataset.spinnerInit) return;
    btn.dataset.spinnerInit = 'true';
    btn.addEventListener('click', () => {
      loadingButton = btn;
      btn.classList.add('is-loading');

      // Check for dialog open state
      checkInterval = setInterval(() => {
        const dialog = document.querySelector('#quick-add-dialog dialog');
        if (dialog && dialog.hasAttribute('open')) {
          removeLoading();
        }
      }, 100);

      // Fallback timeout
      setTimeout(removeLoading, 5000);
    });
  }

  // Initialize a single card's slideshow
  function initR45Card(card) {
    if (!card || card.dataset.cardInit) return;
    card.dataset.cardInit = 'true';

    // Initialize QuickAdd spinner
    initQuickAddSpinner(card);

    // Find media container with slideshow enabled
    const media = card.querySelector('.r45-card-gallery__media[data-has-multiple]');
    if (!media) return;

    const slides = media.querySelector('[data-slides]');
    const prevBtn = media.querySelector('[data-arrow-prev]');
    const nextBtn = media.querySelector('[data-arrow-next]');

    if (!slides || !prevBtn || !nextBtn) return;

    let currentIndex = 0;
    const totalSlides = media.querySelectorAll('[data-slide]').length;

    const allSlides = media.querySelectorAll('[data-slide]');

    // Mobile pagination dots: generate one dot per slide
    const dotsContainer = media.querySelector('[data-dots]');
    let dots = [];
    if (dotsContainer && totalSlides > 1) {
      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('span');
        dot.className = 'r45-card-gallery__dot' + (i === 0 ? ' is-active' : '');
        dotsContainer.appendChild(dot);
      }
      dots = dotsContainer.querySelectorAll('.r45-card-gallery__dot');
    }

    // Load a single deferred image by slide index
    function loadSlideImage(index) {
      if (index < 0 || index >= allSlides.length) return;
      const img = allSlides[index].querySelector('img[data-deferred]');
      if (!img || img.hasAttribute('data-mm-src')) return;
      const realSrcset = img.getAttribute('data-srcset');
      const realSrc = img.getAttribute('data-src');
      if (realSrcset) {
        img.setAttribute('srcset', realSrcset);
        img.removeAttribute('data-srcset');
      }
      if (realSrc) {
        img.src = realSrc;
        img.removeAttribute('data-src');
      }
      img.removeAttribute('data-deferred');
    }

    function scrollToSlide(index) {
      const slideWidth = slides.offsetWidth;
      if (slideWidth === 0) return;
      // Load target image + 1 ahead before scrolling
      loadSlideImage(index);
      loadSlideImage(index + 1);
      slides.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
      currentIndex = index;
    }

    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex > 0 ? currentIndex - 1 : totalSlides - 1;
      scrollToSlide(newIndex);
    });

    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const newIndex = currentIndex < totalSlides - 1 ? currentIndex + 1 : 0;
      scrollToSlide(newIndex);
    });

    // Update currentIndex on scroll/swipe + load target image
    slides.addEventListener('scroll', () => {
      const newIndex = Math.round(slides.scrollLeft / slides.offsetWidth);
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        loadSlideImage(currentIndex);
        loadSlideImage(currentIndex + 1);
        if (dots.length) {
          dots.forEach((d, i) => d.classList.toggle('is-active', i === currentIndex));
        }
      }
    });

    // Touch preload: warm up neighbors the moment user starts swiping
    // so the next image is ready before the swipe animation finishes.
    slides.addEventListener('touchstart', () => {
      loadSlideImage(currentIndex + 1);
      loadSlideImage(currentIndex - 1);
    }, { passive: true });

    // Desktop (>=750px): load all images after main thread is free
    if (window.innerWidth >= 750) {
      requestIdleCallback(() => allSlides.forEach((_, i) => loadSlideImage(i)));
    }

  }

  // Swipe hint: find the first multi-image card in the grid (DOM order = visual order)
  function triggerSwipeHint() {
    if (swipeHintTriggered) return;
    const grid = document.querySelector('.product-grid');
    if (!grid) return;
    const firstMedia = grid.querySelector('.r45-card-gallery__media[data-has-multiple]');
    if (!firstMedia) return;
    swipeHintTriggered = true;

    const hintObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          hintObserver.disconnect();
          const firstImg = firstMedia.querySelector('.r45-card-gallery__image');
          if (firstImg) {
            setTimeout(() => {
              firstImg.classList.add('swipe-hint');
              firstMedia.classList.add('show-hint-arrow');
              setTimeout(() => {
                firstImg.classList.remove('swipe-hint');
                firstMedia.classList.remove('show-hint-arrow');
              }, 1200);
            }, 300);
          }
        }
      });
    }, { threshold: 0.5 });
    hintObserver.observe(firstMedia);
  }

  // Initialize all existing cards
  function initAllR45Cards() {
    document.querySelectorAll('.r45-card-gallery').forEach(initR45Card);
    triggerSwipeHint();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllR45Cards);
  } else {
    initAllR45Cards();
  }

  // Watch for new cards added via infinite scroll
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is a card or contains cards
          if (node.classList && node.classList.contains('r45-card-gallery')) {
            initR45Card(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.r45-card-gallery').forEach(initR45Card);
          }
        }
      });
    });
  });

  // Observe the product grid for new cards
  const grid = document.querySelector('.product-grid');
  if (grid) {
    observer.observe(grid, { childList: true, subtree: true });
  }
})();